"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultConfig = exports.MAX_REFERENCE_LENGTH = void 0;
exports.MAX_REFERENCE_LENGTH = 49;
exports.defaultConfig = {
  baseURL: "http://localhost:8080/POSitiveWebLink/1.1.0/rest",
  headers: {
    Authorization: "Bearer 6945595921271780",
    "Content-Type": "application/json"
  },
  apiLogEnabled: !!process.env.DNA_API_LOG_ENABLED || !!process.env.GATSBY_DNA_API_LOG_ENABLED || false
};